export default {
  getPickingListItem: (state) => state.pickingListItem,
};
